import { render, staticRenderFns } from "./TriggerDataLoadedCheck.vue?vue&type=template&id=3572dc70&"
import script from "./TriggerDataLoadedCheck.vue?vue&type=script&lang=ts&"
export * from "./TriggerDataLoadedCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports